module.exports = __webpack_public_path__ + "img/2_2-residenziale-scuola-2.de7f8e1d.png";